export const OVERFLOW_TOLERANCE_PX = 0;

export const elementHasOverflow = (
  element: Pick<HTMLElement, 'scrollWidth' | 'clientWidth' | 'scrollHeight' | 'clientHeight'>,
): boolean =>
  element.scrollWidth - element.clientWidth > OVERFLOW_TOLERANCE_PX ||
  element.scrollHeight - element.clientHeight > OVERFLOW_TOLERANCE_PX;

const elementHasEllipsisTextOverflow = (element: HTMLElement): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (element.textContent.trim().length === 0) return false;

  const style = window.getComputedStyle(element);
  const clipsInlineText =
    style.textOverflow === 'ellipsis' ||
    style.overflow === 'hidden' ||
    style.overflowX === 'hidden';

  if (!clipsInlineText) return false;

  const visibleWidth = element.getBoundingClientRect().width;
  if (visibleWidth <= 0) return false;

  const range = document.createRange();
  range.selectNodeContents(element);
  const textWidth = range.getBoundingClientRect().width;
  range.detach();

  return textWidth - visibleWidth > OVERFLOW_TOLERANCE_PX;
};

export const elementOrDescendantHasOverflow = (element: HTMLElement): boolean => {
  if (elementHasOverflow(element) || elementHasEllipsisTextOverflow(element)) return true;

  return [...element.querySelectorAll('*')].some((descendant) => {
    if (!(descendant instanceof HTMLElement)) return false;
    return elementHasOverflow(descendant) || elementHasEllipsisTextOverflow(descendant);
  });
};
